import React from 'react';
import { useTranslation } from 'react-i18next';

export interface TabItem {
  id: string;
  name: string;
}

interface TabsProps {
  items: TabItem[];
  activeItem: number;
  onItemClick: ( index: number ) => void;
}

const Tabs: React.FC<TabsProps> = ( { items, activeItem, onItemClick } ) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap justify-center font-comfortaa font-semibold mt-3 relative gap-2">
      {items.length > 0 ? (
        items.map( ( item, index ) => {return (
          <div
            key={item.id}
            className="min-w-[120px] cursor-pointer hover:bg-white rounded-md trans-fast px-3"
            onClick={() => {return onItemClick( index );}}
          >
            <h2 className="mx-4 py-1 text-center truncate text-sm leading-6 font-comfortaa font-semibold">{item.name}</h2>
            <hr
              className={`border-none rounded-full w-full h-[3px] trans-fast shadow ${
                activeItem === index ? 'bg-orange-base-light' : 'bg-white'
              }`}
            />
          </div>
        );} )
      ) : (
        <div className="w-full text-gray-base-dark flex justify-center flex-col items-center">
          <h2 className="mx-4 h-8 w-max text-sm">{t( 'common:no_items' ) || 'Aucun élément trouvé'}</h2>
          <hr className="border-none rounded-full w-full h-[3px] trans-fast shadow bg-white" />
        </div>
      )}
    </div>
  );
};

export default Tabs;
